angular.module('jv.video.request.extension.controller',[])
.controller('requestExtensionModalCtrl', ['$scope', 'formResponseIdService', 'videoService', '$timeout', '$rootScope', '$jobviteUrls', '$window', 'i18n', '$interpolate',
function ($scope, formResponseIdService, videoService, $timeout, $rootScope, $jobviteUrls, $window, i18n, $interpolate) {

    function setSubject() {
        var parsedExp = $interpolate(i18n.REQUEST_EXTENSION);
        $scope.subject = $scope.$eval(parsedExp);
    }

    if (angular.isDefined($scope.summary) && angular.isDefined($scope.summary.job) && angular.isDefined($scope.summary.job.title)) {
        $scope.summary.jobTitle = $scope.summary.job.title;
        setSubject();
    }

    $scope.$on('requestExtensionModalClick', function (event, id, jobTitle) {
        $scope.SId = id;
        $scope.modal.requestExtension = true;
        if (angular.isUndefined($scope.subject) || $scope.subject === '') {
            $scope.summary = angular.isDefined($scope.summary) ? $scope.summary : {};
            $scope.summary.jobTitle = jobTitle;
            setSubject();
        }
    });

    $rootScope.$on('hidingVideoModals', function (e, val) {
        $scope.cleanModal();
    });

    $scope.cleanModal = function () {
        $scope.submitted = false;
        $scope.content = '';
        $scope.subject = '';
        $scope.reqExtensionForm.$setPristine();
    };

    $scope.requestExtension = function (form, index) {
        var videoForm = {};
        videoForm.ID = $scope.SId;
        videoForm.message = $scope.content;
        videoForm.subject = $scope.subject;
        var data = '';
        /* Validation*/
        if ($scope.reqExtensionForm.$invalid) {
            return;
        }
        /*This is to escape the special characters */
        var formContent = encodeURIComponent(videoForm.content);
        var formSubject = encodeURIComponent(videoForm.subject);
        //TODO-PRANAV
        // $scope.modal.evalReqMoreInfo =false;
        // $scope.cleanModal();
        // $scope.showMsg('Request More Information Sent', true);
        //$scope.flags.loading = false;
        videoService.requestExtension(videoForm, function (data) {
            //TODO-PRANAV: Loading Flags need to be implemented.
            $scope.modal.requestExtension = false;
            $scope.cleanModal();
            //VA: Let user see the notification that the message is sent and then redirect to the list page.
            $scope.$emit('showMessageBar', {
                message: i18n.MESSAGE_SENT,
                duration: 950
            });

            $timeout(function () {
                $window.location = $jobviteUrls.video + '/video/jobseeker/jobseekerListview.html';
            }, 1000);

        });
    };
}]);
